export default __webpack_public_path__ + "static/media/office.0513212c.mp3";